import { render, staticRenderFns } from "./DefaultRouterView.vue?vue&type=template&id=ee30a62a&lang=pug"
import script from "./DefaultRouterView.vue?vue&type=script&lang=js"
export * from "./DefaultRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports